"use strict";
// Copyright (c) StrangeBee 2024
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamLongPollingController = void 0;
const __1 = require("..");
const fetch_event_source_1 = require("@microsoft/fetch-event-source");
class StreamController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            stream: '/v1/stream',
            initial: '/v1/flow',
        };
    }
    getStream(options = {}) {
        const sender = this.manager.sender;
        const url = sender.getBaseUrl() + sender.buildUrl({ url: this.endpoints.stream });
        const { onmessage } = options, rest = __rest(options, ["onmessage"]);
        return (0, fetch_event_source_1.fetchEventSource)(url, Object.assign({ method: 'GET', onmessage: (event) => {
                if (onmessage) {
                    const audit = JSON.parse(event.data);
                    onmessage(audit);
                }
            } }, rest));
    }
    getInitialFeed(rootId, count = 10) {
        return this.manager.get({
            url: this.endpoints.initial,
        }, {
            params: {
                count,
                rootId: rootId || 'any',
            },
        });
    }
}
class StreamLongPollingController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            id: '/v1/stream',
            feed: '/v1/stream/:streamId',
            initial: '/v1/flow',
        };
        this.controller = null;
    }
    getId() {
        return this.manager.post({ url: this.endpoints.id });
    }
    getFeed(streamId, timeout = 0) {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        return this.manager.getFullResponse({ url: this.endpoints.feed, params: { streamId } }, { timeout, signal });
    }
    cancelFeed() {
        if (this.controller) {
            this.controller.abort();
        }
        return Promise.resolve('Feed canceled');
    }
    getInitialFeed(rootId, count = 10) {
        return this.manager.get({
            url: this.endpoints.initial,
        }, {
            params: {
                count,
                rootId: rootId || 'any',
            },
        });
    }
}
exports.StreamLongPollingController = StreamLongPollingController;
exports.default = StreamController;
